import React from 'react';
import {Link} from 'react-router-dom';

import './css/footer.css';
import {ReactComponent as CitySkyline} from './img/decoration-city.svg';

function Footer (){
    return (
        <div className="site-footer">
            <div className="footer-skyline"><CitySkyline/></div>
            <div className="footer-content">
                <span className="footer-word">Dorms @ Brown</span>
                <div className="footer-links">
                    <Link to="/about">About</Link>
                    <Link to="/dorms">Dorms</Link>
                    <Link to="/recommend">Recommendations</Link>
                </div>
            </div>
        </div>
    )
}

export default Footer;
